const baseURL = new URL(window.location.origin);
export const createURL = (url: string) => new URL(url, baseURL);

// Authentications
export const SINGLE_SIGN_ON_SIGN_IN = '/sign_in/sso';
export const SIGN_IN_SAML_SIGNUP = '/sign_in/saml/signup';
export const SIGN_IN_SAML_LINK_EMAIL = '/sign_in/saml/link';
export const FORGOT_PASSWORD = '/passwords/new';

export const CITATION_IMPORTS = '/api/v1/citation_imports';
export const CITATION_IMPORTS_DELETE =
  '/reviews/{review_id}/citation_imports/{citation_import_id}';
export const CITATION_IMPORT_SOURCES_UPDATE =
  'api/v1/citation_imports/{citation_import_id}/citation_import_sources';
export const DUPLICATES_ROUTE = '/reviews/{review_id}/duplicates';
export const EXTRACTION_STUDIES_LIST_ROUTE =
  '/reviews/{review_id}/review_studies/included?filter=ready_for_extraction';

export const REVIEW_IMPORT_SOURCES =
  '/api/v1/reviews/{review_id}/review_citation_import_sources';
export const REVIEW_IMPORT_SOURCES_DELETE =
  '/api/v1/reviews/{review_id}/review_citation_import_sources/{id}';
export const UNMERGE_STUDY = '/api/v1/studies/{study_id}/unmerge';
export const CRITERIA = '/api/reviews/v1/reviews/{review_id}/criteria';
export const HIGHLIGHTS = '/api/reviews/v1/reviews/{review_id}/highlights';
export const EXCLUSION_REASONS =
  '/api/reviews/v1/reviews/{review_id}/exclusion_reasons';

export const SEARCH_RESULTS = '/api/reviews/v1/reviews/{review_id}/search';
export const LIBKEY_ARTICLES = '/api/libkey/v1/reviews/{review_id}/articles';
export const REVIEW_REFERENCES =
  '/api/reviews/v1/reviews/{review_id}/references';

export const REVIEW_REFERENCE =
  '/reviews/{reviewId}/review_studies/{studyId}/review_references/{reviewReferenceId}.json';

// Review details
export const REVIEW_DETAILS = '/reviews/{review_id}/details';
export const REVIEW_CRITERIA = '/reviews/{review_id}/criteria';
export const REVIEW_PRISMA = '/reviews/{review_id}/prisma';
export const REVIEW_EXPORT = '/reviews/{review_id}/exports/new';
export const REVIEW_TAGS = '/api/reviews/v1/reviews/{review_id}/tags';
export const CREATE_REVIEW_TAG = '/reviews/{review_id}/tags';
export const ADD_REVIEW_TAG_TO_STUDY =
  '/api/reviews/v1/reviews/{review_id}/studies/tags';
export const UPDATE_REVIEW_ARCHIVAL_STATUS = `/reviewers/{reviewer_id}/reviews/{review_id}`;

// Review setup
export const REVIEW_SETUP = '/reviews/{review_id}/review_setup';
export const REVIEW_SETUP_CRITERIA =
  '/reviews/{review_id}/review_setup/criteria';
export const REVIEW_SETUP_HIGHLIGHTS =
  '/reviews/{review_id}/review_setup/highlights';
export const REVIEW_SETUP_EXCLUSION_REASONS =
  '/reviews/{review_id}/review_setup/exclusion_reasons';
export const REVIEW_SETUP_DELETE_EXCLUSION_REASON =
  '/reviews/{review_id}/review_setup/exclusion_reasons/{exclusion_reason_id}';
export const REVIEW_SETUP_EXCLUSION_REASON_POSITIONS =
  '/reviews/{review_id}/review_setup/exclusion_reasons/set_positions';

// Using screening endpoint for now until real endpoint is built
export const AUTO_EXCLUSIONS = '/reviews/{review_id}/auto_excluded_studies';

export const LATEST_AUTO_EXCLUSION_BATCH =
  '/api/reviews/v1/reviews/{review_id}/auto_exclusion_batches/latest';
export const REVIEW_SUMMARY = '/api/reviews/v1/reviews/{review_id}/summary';
export const REVIEW_STAGE_STATISTICS =
  '/api/reviews/v1/reviews/{review_id}/statistics/{stage}';
export const REVIEW_STAGE_CONTRIBUTION =
  '/api/reviews/v1/reviews/{review_id}/statistics/{stage}/contribution';
export const REVIEW_FEATURE_FLAG_ROUTE =
  '/api/reviews/v1/reviews/{review_id}/features';
export const UPDATE_REVIEW_SETTINGS_ROUTE =
  '/api/reviews/v1/reviews/{review_id}/review_settings';

// Data Extration Suggestions
export const STUDY_AUTO_DOCUMENT_FIELD_EXTRACTION =
  '/api/extraction/v1/review_studies/{studyId}/documents/{documentId}/auto_extractions/{fieldName}';

export const STUDY_AUTO_DOCUMENT_EXTRACTIONS =
  '/api/extraction/v1/review_studies/{studyId}/documents/{documentId}/auto_extractions';

// Data Extraction Templates
export const DATA_EXTRACTION_TEMPLATE_CREATE_OR_EDIT_ROUTE =
  '/reviews/{review_id}/data_extraction_template';
export const EXTRACT_DATA_ROUTE =
  '/reviews/{review_id}/review_studies/{study_id}/data_extractions';
export const DATA_EXTRACTION_TEMPLATE_API_ROUTE =
  '/api/extraction/v1/reviews/{review_id}/templates/data_extraction';
export const COPY_DATA_EXTRACTION_TEMPLATE_API_ROUTE =
  '/api/extraction/v1/reviews/{review_id}/templates/data_extraction/copy';
export const REVIEWS_WITH_COPYABLE_TEMPLATES_ROUTE =
  '/api/extraction/v1/reviews/{review_id}/templates/data_extraction/copyable';

// Quality Assessment Templates
export const QUALITY_ASSESSMENT_TEMPLATE_CREATE_ROUTE =
  '/reviews/{review_id}/qa_template';
export const QUALITY_ASSESSMENT_CUSTOM_TEMPLATE_CREATE_ROUTE =
  '/reviews/{review_id}/qa_template/default';
export const QUALITY_ASSESSMENT_TEMPLATE_API_ROUTE =
  '/api/extraction/v1/reviews/{review_id}/templates/quality_assessment';

// Data Extraction
export const DATA_EXTRACTION_ROUTE =
  '/api/extraction/v1/review_studies/{review_study_id}/data_extraction';

// Data Extraction 2 Templates
export const DATA_EXTRACTION_2_TEMPLATE_CREATE_OR_EDIT_ROUTE = `/reviews/{review_id}/extraction/build?extraction_form_type=data_extraction`;
export const DE2_QUALITY_ASSESSMENT_TEMPLATE_CREATE_ROUTE = `/reviews/{review_id}/extraction/build?extraction_form_type=quality_assessment`;

// Data Extraction: Identifications
export const CREATE_IDENTIFICATION_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/identifications`;

// Data Extraction: Methods (`study_designs` table)
export const CREATE_METHODS_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/study_designs`;

// Data Extraction: Participants and Pretreatments
export const CREATE_PARTICIPANT_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/participants`;
export const CREATE_PRETREATMENT_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/pretreatments`;

// Data Extraction: Baseline Characteristics
export const BASELINE_CHARACTERISTIC_RESULTS_ROUTE =
  '/api/extraction/v1/review_studies/{review_study_id}/data_extraction/baseline_characteristics/{baseline_characteristic_id}/results';

// Data Extraction: Custom Field Values
export const CREATE_CUSTOM_FIELD_VALUES_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/custom_field_values`;

// Data Extraction: Interventions and Arms
export const CHECK_INTERVENTION_EXTRACTED_DATA_ROUTE =
  'api/extraction/v1/review_studies/{review_study_id}/interventions/{intervention_id}/extracted';
export const INTERVENTION_CHARACTERISTIC_RESULTS_ROUTE =
  '/api/extraction/v1/review_studies/{review_study_id}/data_extraction/intervention_characteristics/{intervention_characteristic_id}/results';
export const CREATE_STUDY_ARM_ROUTE =
  '/api/extraction/v1/review_studies/{review_study_id}/data_extraction/arms';
export const STUDY_ARM_ROUTE = '/api/extraction/v1/arms/{arm_id}';
export const GET_ARMS_EXISTING_EXTRACTION_ROUTE =
  '/api/extraction/v1/arms/{arm_id}/extracted';
export const UPDATE_STUDY_ARM_POSITIONS_ROUTE =
  '/api/extraction/v1/review_studies/{review_study_id}/data_extraction/arms/set_positions';

// Data Extraction: Outcomes
export const CREATE_OUTCOME_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/outcomes`;
export const UPDATE_OUTCOME_ROUTE = `/api/extraction/v1/outcomes/{outcome_id}`;
export const DESTROY_OUTCOME_ROUTE = `/api/extraction/v1/outcomes/{outcome_id}`;
export const SET_OUTCOME_POSITIONS_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/outcomes/set_positions`;
export const CHECK_TEMPLATE_OUTCOME_EXTRACTED_DATA_ROUTE =
  'api/extraction/v1/review_studies/{review_study_id}/data_extraction_template/outcomes/{template_outcome_id}/extracted';
export const CHECK_STUDY_OUTCOME_EXTRACTED_DATA_ROUTE =
  'api/extraction/v1/outcomes/{outcome_id}/extracted';
export const SAVE_OUTCOME_DETAIL_ROUTE = `/api/extraction/v1/outcomes/{outcome_id}/outcome_detail_values/upsert`;

// Data Extraction: Timepoints
export const CREATE_TIMEPOINT_ROUTE = `/api/extraction/v1/outcomes/{outcome_id}/timepoints`;
export const UPDATE_TIMEPOINT_ROUTE = `/api/extraction/v1/timepoints/{timepoint_id}`;
export const DESTROY_TIMEPOINT_ROUTE = `/api/extraction/v1/timepoints/{timepoint_id}`;
export const CHECK_TIMEPOINT_EXTRACTED_DATA_ROUTE =
  '/api/extraction/v1/timepoints/{timepoint_id}/extracted';

// Data Extraction: Notes
export const CREATE_STUDY_NOTE_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/notes`;
export const UPDATE_STUDY_NOTE_ROUTE = `/api/extraction/v1/review_studies/{review_study_id}/notes/{note_id}`;

// Data Extraction: Results
export const SAVE_RESULT = `/api/extraction/v1/review_studies/{review_study_id}/data_extraction/results/upsert`;
export const CREATE_OUTCOME_RESULT = `/api/extraction/v1/outcomes/{outcome_id}/outcome_results`;
export const REPLACE_OUTCOME_RESULT = `/api/extraction/v1/outcome_results/{outcome_result_id}/replace`;
export const DELETE_OUTCOME_RESULT = `/api/extraction/v1/outcome_results/{outcome_result_id}`;
export const ANY_RESULTS_EXTRACTED = `/api/extraction/v1/outcome_results/{outcome_result_id}/extracted`;
export const UPDATE_OUTCOME_RESULT_POSITIONS_ROUTE =
  '/api/extraction/v1/review_studies/{review_study_id}/data_extraction/outcomes/{outcome_id}/outcome_results/set_positions';

// Data Extraction: Manage Reviewers
export const MANAGE_REVIEWERS_ROUTE =
  '/reviews/{review_id}/review_studies/{study_id}/manage_reviewers';

// Reviewer
export const REVIEWER_FEATURE_FLAG_ROUTE = '/api/reviewers/v1/features';
export const CURRENT_REVIEWER_ROUTE = '/api/reviewers/v1/current_reviewer';
export const UPDATE_REVIEWER_PROFILE_ROUTE = '/profile';

// Audit Events
export const AUDIT_EVENTS_ROUTE =
  '/reviews/{review_id}/review_studies/{study_id}/audit_events';

// Exclusion Reasons
export const DELETE_EXCLUSION_REASON =
  '/reviews/{review_id}/exclusion_reasons/{reason_id}';
export const ADD_EXCLUSION_REASON = '/reviews/{review_id}/exclusion_reasons';

// Notes
export const NOTES_ROUTE = '/api/v1/notes';
export const NOTE_ROUTE = '/api/v1/notes/{note_id}';

// Votes
export const VOTES_ROUTE =
  '/reviews/{review_id}/review_studies/{study_id}/votes';

// Review Metric
export const REVIEW_METRIC_ROUTE =
  '/api/reviews/v1/reviews/{review_id}/review_metrics';

// Choose Your Template
export const CHOOSE_YOUR_TEMPLATE_ROUTE =
  '/reviews/{review_id}/choose_your_template';

export const REVIEW_SUMMARY_ROUTE = '/reviews/{review_id}';

// Back navigation type for Choose Your Template flow to prevent open redirect vulnerabilities
export type BackTo = 'study_list' | 'review_summary';

export const resolveBackTo = (
  backTo: string | null,
  reviewId: string | null
): URL => {
  const safeBackTo: BackTo =
    backTo === 'study_list' ? 'study_list' : 'review_summary';

  const route =
    safeBackTo === 'study_list'
      ? EXTRACTION_STUDIES_LIST_ROUTE
      : REVIEW_SUMMARY_ROUTE;

  return tokenizeRoute(route, { review_id: reviewId });
};

// URL back to the Choose Your Template page helper
export const getChooseYourTemplateBackRoute = ({
  reviewId,
  type,
  backTo,
  skipSelector,
}: {
  reviewId: string | null;
  type: 'de' | 'qa';
  backTo: string | null;
  skipSelector?: boolean;
}): URL => {
  const safeBackTo: BackTo =
    backTo === 'study_list' ? 'study_list' : 'review_summary';

  if (skipSelector) {
    return resolveBackTo(safeBackTo, reviewId);
  }

  return tokenizeRoute(CHOOSE_YOUR_TEMPLATE_ROUTE, {
    review_id: reviewId,
    type,
    backTo: safeBackTo,
  });
};

// Get the correct template route based on type and DE version
export const getTemplateRoute = ({
  isDe2,
  reviewId,
  type,
  backTo,
}: {
  isDe2: boolean;
  reviewId: string | null;
  type: 'de' | 'qa';
  backTo?: BackTo;
}) => {
  const routes = {
    de: isDe2
      ? DATA_EXTRACTION_2_TEMPLATE_CREATE_OR_EDIT_ROUTE
      : DATA_EXTRACTION_TEMPLATE_CREATE_OR_EDIT_ROUTE,
    qa: isDe2
      ? DE2_QUALITY_ASSESSMENT_TEMPLATE_CREATE_ROUTE
      : QUALITY_ASSESSMENT_TEMPLATE_CREATE_ROUTE,
  };

  const tokens: Record<string, any> = { review_id: reviewId };
  if (backTo) {
    tokens.backTo = backTo;
  }
  tokens.type = type;

  return tokenizeRoute(routes[type], tokens);
};

/**
 * Replace route tokens with values. Also add any search params to non-tokenized routes.
 * @param route
 * @param tokens
 */
export const tokenizeRoute = (route: string, tokens: any) => {
  // extract tokens to replace in route
  const rawTokens = Array.from(route.matchAll(/{(.*?)}/g), (match) => match[0]);

  // map them into an object of raw tokens (including the {}), and stripped tokens to match with the input tokens
  const tokenMap = rawTokens.reduce<any>((obj, rawToken) => {
    const strippedToken = rawToken.slice(1, -1);
    const rtn = { ...obj };
    rtn[strippedToken] = rawToken;
    return rtn;
  }, {});

  let outputRoute = route;
  const params: any = {};

  // Replace route tokens with input token values
  Object.keys(tokens).forEach((token) => {
    if (tokenMap[token]) {
      outputRoute = outputRoute.replace(tokenMap[token], tokens[token]);
      delete tokenMap[token];
    } else {
      // If there is no matching token, add it as a search param
      params[token] = tokens[token];
    }
  });

  if (Object.keys(tokenMap).length > 0)
    throw new Error(`Missing tokens: ${Object.keys(tokenMap).join(',')}`);

  // Put any additional params on the route
  const url = createURL(outputRoute);
  Object.keys(params).forEach((key) => {
    url.searchParams.set(key, params[key]);
  });

  return url;
};
